import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular/standalone';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PwaDeviceService {
  constructor(private readonly platform: Platform) {}

  /** App nativo sempre; PWA/web só em celular ou tablet (produção). */
  isWebAccessAllowed(): boolean {
    if (Capacitor.isNativePlatform()) {
      return true;
    }

    if (!environment.production) {
      return true;
    }

    return this.isMobileDevice();
  }

  private isMobileDevice(): boolean {
    if (this.platform.is('mobile') || this.platform.is('tablet')) {
      return true;
    }

    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|android|mobile/.test(ua)) {
      return true;
    }

    // iPadOS 13+ pode reportar "Macintosh" no Safari
    if (/macintosh/.test(ua) && 'ontouchstart' in window) {
      return true;
    }

    return false;
  }
}
